// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"ee4ab2ab","239":"5491b2ce","389":"d2b5287b","732":"a38800b4","977":"cfa13509"}[chunkId] + ".chunk.js";
};